module.exports = __webpack_public_path__ + "img/k9-logo-basic.891a30a0.svg";